import { IDealsArticleConfig, TDealsContentConfig } from '../../types/dealsContentConfig';

/**
 * Возвращает конфиг статьи для фичи «Сделка», если она есть в RS dealsContentConfig.
 */
export const getDealsArticleConfig = (
  postId: number,
  dealsContentConfig: TDealsContentConfig | null,
): IDealsArticleConfig | undefined => {
  if (dealsContentConfig === null) {
    return undefined;
  }

  return dealsContentConfig[String(postId)];
};
